__turbopack_context__.v({
  "active": "styles-module___ZruDG__active",
  "black": "styles-module___ZruDG__black",
  "button": "styles-module___ZruDG__button",
  "dark": "styles-module___ZruDG__dark",
  "default": "styles-module___ZruDG__default",
  "ghost": "styles-module___ZruDG__ghost",
  "gray": "styles-module___ZruDG__gray",
  "icnSm": "styles-module___ZruDG__icnSm",
  "iconLeft": "styles-module___ZruDG__iconLeft",
  "iconRight": "styles-module___ZruDG__iconRight",
  "lg": "styles-module___ZruDG__lg",
  "light": "styles-module___ZruDG__light",
  "link": "styles-module___ZruDG__link",
  "loading": "styles-module___ZruDG__loading",
  "md": "styles-module___ZruDG__md",
  "outline": "styles-module___ZruDG__outline",
  "red": "styles-module___ZruDG__red",
  "sm": "styles-module___ZruDG__sm",
  "spin": "styles-module___ZruDG__spin",
  "spinner": "styles-module___ZruDG__spinner",
  "text": "styles-module___ZruDG__text",
  "transparent": "styles-module___ZruDG__transparent",
  "white": "styles-module___ZruDG__white",
});
